module.exports = __webpack_public_path__ + "assets/images/icons/visa_icon.ce99a5edc765696a212a278d8d4198d4.svg";